"use client";

import React, { useState } from "react";
import { AppCard, AppCardData } from "./AppCard";
import { AppsSearchAndFilter } from "./AppsSearchAndFilter";

const appsData: AppCardData[] = [
  {
    id: "digital-menu-board",
    title: "Digital Menu Board",
    category: "QSR",
    description: "Design dynamic menu boards with easy pricing & offers.",
    href: "/solutions/digital-menu-board/",
    icon: "apps-icon-digital-menu-board.bNOF65baZlP_.svg",
    previewImage: "digital-menu-preview.kPdWeAPtiYYu.webp",
    colorClass: "card--color1",
    dataCategory: "qsr",
  },
  {
    id: "weather",
    title: "Weather",
    category: "Business",
    description: "Show live weather feeds on your digital signage display.",
    href: "/digital-signage-apps/weather",
    icon: "apps-icon-weather.J8i8gmUE66uk.svg",
    previewImage: "weather-preview.D48uguiUxljB.webp",
    colorClass: "card--color4",
    dataCategory: "business",
  },
  {
    id: "scroller",
    title: "Scroller",
    category: "Social media",
    description: "Display announcements, alerts, & trivia as scrolling text.",
    href: "/digital-signage-apps/scrolling-text",
    icon: "apps-icon-scroller.Cdh7fMimBouD.svg",
    previewImage: "Scroller-preview.BsIyToGmc9vt.webp",
    colorClass: "card--color1",
    dataCategory: "communications",
  },
  {
    id: "bbc-news",
    title: "BBC News",
    category: "News",
    description: "Get the latest news and coverage from the BBC app.",
    href: "/digital-signage-apps/bbc-news-feeds",
    icon: "bbc.DZj5Q3210jp-.svg",
    previewImage: "bbc-preview.2LfO2HiIVRlW.webp",
    colorClass: "card--color2",
    dataCategory: "news",
  },
  {
    id: "rss-feed",
    title: "RSS Feed",
    category: "News",
    description: "Display live RSS feeds of blogs, news, sports & more.",
    href: "/digital-signage-apps/rss-feed",
    icon: "apps-icon-rss.C3brbBVRk9Q4.svg",
    previewImage: "rss-preview.XDclmtVLA3sI.webp",
    colorClass: "card--color3",
    dataCategory: "news",
  },
  {
    id: "world-clock",
    title: "Clock",
    category: "Business",
    description: "Display accurate time of any location on your displays.",
    href: "/digital-signage-apps/world-clock",
    icon: "clock.DVco00T6l94k.svg",
    previewImage: "clock-preview.r2PyH_8-c0hg.webp",
    colorClass: "card--color4",
    dataCategory: "business",
  },
  {
    id: "aqi",
    title: "AQI",
    category: "Business",
    description: "Show outdoor air quality index & health risk indicators.",
    href: "/digital-signage-apps/air-quality-index",
    icon: "apps-icon-aqi.bZ-LLiGgXjjH.svg",
    previewImage: "aqi-preview.u9js_2pfbSK2.webp",
    colorClass: "card--color3",
    dataCategory: "business",
  },
  {
    id: "web-url",
    title: "Web URL",
    category: "Communications",
    description: "Display any website on your smart screen with https link.",
    href: "/digital-signage-apps/web-url",
    icon: "apps-icon-url-new.hTNVAJbWgoWZ.svg",
    previewImage: "web-url-preview.Jq-QbqHI12eB.webp",
    colorClass: "card--color3",
    dataCategory: "communications",
  },
  {
    id: "youtube",
    title: "Youtube",
    category: "Social media",
    description: "Play anything from YouTube without pre-local downloads.",
    href: "/digital-signage-apps/youtube-videos",
    icon: "apps-icon-youtube.do_I37JTMdf_.svg",
    previewImage: "youtube-preview.Ttj0f0NSQcZK.webp",
    colorClass: "card--color1",
    dataCategory: "",
  },
  {
    id: "google-slides",
    title: "Google Slides",
    category: "Business",
    description: "Share presentations in real-time, directly on your screens.",
    href: "/digital-signage-apps/google-slides",
    icon: "apps-icon-google-slides.oLO6Juk7y14A.svg",
    previewImage: "google-slides-preview.n-CvNvv6L0F-.webp",
    colorClass: "card--color5",
    dataCategory: "business",
  },
  {
    id: "power-bi",
    title: "Power BI",
    category: "Business",
    description: "Display Power BI dashboards easily on signage screens.",
    href: "/digital-signage-dashboard/power-bi/",
    icon: "apps-icon-power-bi.v6jLAITdBiaJ.svg",
    previewImage: "power-bi-preview.hwLbsUj04DHO.webp",
    colorClass: "card--color5",
    dataCategory: "business",
  },
  {
    id: "product-catalogue",
    title: "Product Catalogue",
    category: "Business",
    description: "Enable purchase decisions with Pickcel Product Catalogue.",
    href: "/solutions/digital-product-catalogue/",
    icon: "product-catalogue.chGaRYVTl4TI.svg",
    previewImage: "catalogue-preview.c562Ugd4eoFI.webp",
    colorClass: "card--color2",
    dataCategory: "business",
  },
  {
    id: "qr-code",
    title: "QR Code",
    category: "Business",
    description: "Get interactions with QR code displays for offers & more.",
    href: "/digital-signage-apps/qr-code",
    icon: "apps-icon-qrcode.6eTHawiL_EDv.svg",
    previewImage: "qr-code-preview.xkqNNDewUEgl.webp",
    colorClass: "card--color4",
    dataCategory: "business",
  },
  {
    id: "microsoft-team",
    title: "Microsoft Team",
    category: "Business",
    description: "Share team reports and files on your digital signage screens.",
    href: "/digital-signage-apps/app-for-microsoft",
    icon: "apps-icon-microsoft-team.1IqCBPsPS8ht.svg",
    previewImage: "teams-preview.JKEgmN1uo5pG.webp",
    colorClass: "card--color1",
    dataCategory: "business",
  },
  {
    id: "meeting-your-team",
    title: "Meet Your Team",
    category: "Communications",
    description: "Show meeting schedules from Google Meet on your screens.",
    href: "/digital-signage-apps/meet-your-team",
    icon: "meet-your-team.akil2qafayOF.svg",
    previewImage: "meet-your-team-preview.bXlPb34OFYAm.jpg",
    colorClass: "card--color3",
    dataCategory: "communications",
  },
  {
    id: "instastream",
    title: "Event Stream",
    category: "Business",
    description: "Live Stream to Your Digital Signage from Any Device.",
    href: "/solutions/digital-signage-streaming/",
    icon: "apps-icon-insta-stream.KY94PIB_hTIC.svg",
    previewImage: "instastream-preview.05xRFDRG-H7x.webp",
    colorClass: "card--color3",
    dataCategory: "business",
  },
  {
    id: "dashboard",
    title: "Dashboard",
    category: "Business",
    description: "Show live dashboard data securely on any screen.",
    href: "/digital-signage-dashboard/",
    icon: "dashboard.TAA7y3GrfcDG.svg",
    previewImage: "dashboard-preview.lkGq9wPZuseP.webp",
    colorClass: "card--color1",
    dataCategory: "business",
  },
  {
    id: "car-dealership",
    title: "Car Dealership",
    category: "Business",
    description: "Showcase top car models on dynamic digital screens.",
    href: "/solutions/car-dealership-digital-signage/",
    icon: "apps-icon-dealership.sV2cUrZagnaI.svg",
    previewImage: "dealership-preview.Ws5JBh4TLjg0.webp",
    colorClass: "card--color1",
    dataCategory: "business",
  },
  {
    id: "people-space",
    title: "People Space",
    category: "Communications",
    description: "Highlight staff, guests, or stories on visual walls.",
    href: "/digital-signage-apps/people-space",
    icon: "apps-icon-people-space.bLaoTKXajGdK.svg",
    previewImage: "people-space-preview.9MPcuDs0Pzl5.webp",
    colorClass: "card--color1",
    dataCategory: "communications",
  },
  {
    id: "social-wall",
    title: "Social Wall",
    category: "Social media",
    description: "Stream live posts from Instagram, X, & Facebook.",
    href: "/solutions/digital-signage-social-wall",
    icon: "apps-icon-social-wall.mjTO4lEEuW1h.svg",
    previewImage: "social-wall-preview.cz1lA10I_7tF.webp",
    colorClass: "card--color4",
    dataCategory: "communications",
  },
  {
    id: "text-board",
    title: "Text Board",
    category: "Communications",
    description: "Type and display messages instantly on any screen.",
    href: "/digital-signage-apps/text-board",
    icon: "apps-icon-text-app.X33puU4RI4BQ.svg",
    previewImage: "text-preview.mNo9sb-8QLcm.webp",
    colorClass: "card--color1",
    dataCategory: "communications",
  },
  {
    id: "slack",
    title: "Slack",
    category: "Business",
    description: "Display your Slack messages on your display",
    href: "/digital-signage-apps/app-for-slack",
    icon: "apps-icon-slack.IrlxyPcwg2VI.svg",
    previewImage: "slack-preview.2IiiRLYJ8G4V.webp",
    colorClass: "card--color1",
    dataCategory: "business",
  },
  {
    id: "flight-information",
    title: "Flight Information System",
    category: "Business",
    description: "Build flight boards & publish them on your screens.",
    href: "/solutions/digital-signage-flight-information",
    icon: "apps-icon-flight-app-icon-small.PLUQdb-SPmD2.svg",
    previewImage: "flight-preview.junW8iz7JJVX.webp",
    colorClass: "card--color2",
    dataCategory: "business",
  },
  {
    id: "live-streaming",
    title: "Live Streaming",
    category: "Business",
    description: "Stream events live to engage wider digital audiences.",
    href: "/digital-signage-apps/live-web-stream",
    icon: "apps-icon-streaming.ePRQoqaCdn9_.svg",
    previewImage: "stream-preview.Ri0S-Z2g4g6V.webp",
    colorClass: "card--color4",
    dataCategory: "business",
  },
  {
    id: "bulletin-board",
    title: "Bulletin Board",
    category: "Business",
    description: "Show important text messages on your digital screens.",
    href: "/digital-signage-apps/bulletin-board-app",
    icon: "apps-icon-bulletin-board-app.EnbSLayg0eD2.svg",
    previewImage: "bulletin-board-preview.jPDMzi46yPun.webp",
    colorClass: "card--color5",
    dataCategory: "business",
  },
  {
    id: "hdmi",
    title: "HDMI",
    category: "Business",
    description: "Switch between your hdmi & signage contents.",
    href: "",
    icon: "apps-icon-hdmi.W27H0vNxS1aL.svg",
    previewImage: "hdmi-preview.RHHiTk4NsCsj.webp",
    colorClass: "card--color2",
    dataCategory: "business",
  },
  {
    id: "quotes",
    title: "Quotes",
    category: "Business",
    description: "Show inspiring quotes to uplift team morale daily.",
    href: "/digital-signage-apps/quotes",
    icon: "apps-icon-quote.OTVVzGpV3oak.svg",
    previewImage: "quotes-preview.hq9FVhxNIgo0.webp",
    colorClass: "card--color5",
    dataCategory: "business",
  },
  {
    id: "cnn-news",
    title: "CNN News",
    category: "News",
    description: "Get the latest news coverage from CNN app.",
    href: "/digital-signage-apps/cnn-news-feeds",
    icon: "apps-icon-cnn.huuwlQA9hvkz.svg",
    previewImage: "cnn-preview.9i6c9Hcd1fk9.webp",
    colorClass: "card--color4",
    dataCategory: "news",
  },
  {
    id: "ndtv-news",
    title: "NDTV News",
    category: "News",
    description: "Get the latest news coverage from NDTV app.",
    href: "/digital-signage-apps/ndtv-news-feeds",
    icon: "apps-icon-NDTV.THLemVFtwu5B.svg",
    previewImage: "ndtv-preview.T3DKGcbCk55V.webp",
    colorClass: "card--color3",
    dataCategory: "news",
  },
  {
    id: "espn-news",
    title: "ESPN News",
    category: "News",
    description: "Show live sports updates on your digital signage",
    href: "/digital-signage-apps/espn-news-feeds",
    icon: "apps-icon-espn.OBQx2tWUhyhe.svg",
    previewImage: "espn-preview.y-WO7svyeUP_.webp",
    colorClass: "card--color3",
    dataCategory: "news",
  },
  {
    id: "toi-news",
    title: "TOI News",
    category: "News",
    description: "Get the latest news coverage from the TOI app.",
    href: "/digital-signage-apps/toi-news-feeds",
    icon: "apps-icon-toi-news.fi6by4OSW9OK.svg",
    previewImage: "toi-preview.znM1T1V-Hqix.webp",
    colorClass: "card--color1",
    dataCategory: "news",
  },
  {
    id: "fox-news",
    title: "Fox News",
    category: "News",
    description: "Show the latest Fox News headlines on your screen.",
    href: "/digital-signage-apps/fox-news-feeds",
    icon: "apps-icon-fox.7l-hoq7iVWN2.svg",
    previewImage: "fox-news-preview.mXavMviqWbvT.webp",
    colorClass: "card--color2",
    dataCategory: "news",
  },
  {
    id: "wsj-news",
    title: "Wall Street Journal",
    category: "News",
    description: "Get the latest news coverage from the WSJ app.",
    href: "/digital-signage-apps/wall-street-journal-news-feeds",
    icon: "apps-icon-wsj.OFBbTXkJEmvL.svg",
    previewImage: "wall-street-preview.tUyoM3GhWAmT.webp",
    colorClass: "card--color2",
    dataCategory: "news",
  },
  {
    id: "nyt-news",
    title: "NYT News",
    category: "News",
    description: "Get the latest stories from the New York Times app.",
    href: "/digital-signage-apps/nytimes-news-feeds",
    icon: "apps-icon-NYT.wDk3bMQ-aVrb.svg",
    previewImage: "nyt-preview.EZNKeQO0IZsv.webp",
    colorClass: "card--color2",
    dataCategory: "news",
  },
  {
    id: "facebook",
    title: "Facebook",
    category: "Social media",
    description: "Engage your audience with live videos and feeds.",
    href: "/digital-signage-apps/facebook-feeds",
    icon: "apps-icon-facebook-plus.DTd9TZs63Bhc.svg",
    previewImage: "facebook-preview.ha0ovyjC6xuL.webp",
    colorClass: "card--color2",
    dataCategory: "social",
  },
  {
    id: "instagram",
    title: "Instagram",
    category: "Social media",
    description: "Display your latest reels & posts for more visibility.",
    href: "/digital-signage-apps/instagram-feeds",
    icon: "apps-icon-Instagram.q8TGobrOc-Y0.svg",
    previewImage: "instagram-preview.1rdC_3XLKTCq.webp",
    colorClass: "card--color4",
    dataCategory: "social",
  },
  {
    id: "twitter",
    title: "Twitter",
    category: "Social media",
    description: "Show trending tweets & brand activity on your screen.",
    href: "/digital-signage-apps/twitter-feeds",
    icon: "apps-icon-twitter-plus-new.WG1Kzia73lTj.svg",
    previewImage: "x-preview.k6QpZQMrIEst.webp",
    colorClass: "card--color3",
    dataCategory: "social",
  },
  {
    id: "stocks-market-watch",
    title: "Stocks Market Watch",
    category: "Finance",
    description: "Show live stock prices & indices on your displays.",
    href: "/digital-signage-apps/stocks",
    icon: "apps-icon-stocks.i6p2Mof4gShe.svg",
    previewImage: "stock-market-watch-preview.A0gFZ46_ZIe3.webp",
    colorClass: "card--color3",
    dataCategory: "business",
  },
  {
    id: "sharepoint",
    title: "Sharepoint",
    category: "Business",
    description: "Display Sharepoint dashboards on your digital signage.",
    href: "/digital-signage-apps/sharepoint",
    icon: "share-point.HvJK_fpEbD53.svg",
    previewImage: "sharepoint-preview.z-_JuPvUcxFk.webp",
    colorClass: "card--color1",
    dataCategory: "business",
  },
  {
    id: "onedrive",
    title: "OneDrive",
    category: "Business",
    description: "Display images & videos from a OneDrive folder on your screens.",
    href: "/digital-signage-apps/onedrive",
    icon: "onedrive.svg",
    previewImage: "onedrive-app/banner-image.ctPYhss6eAZN.webp",
    colorClass: "card--color3",
    dataCategory: "business",
  },
  {
    id: "campaign",
    title: "Campaign",
    category: "Business",
    description: "Run and manage advertising campaigns across your digital screens with precision.",
    href: "/digital-signage-apps/campaign",
    icon: "campaign.e69tuR_9IlAw.svg",
    previewImage: "campaign-app-preview.WidOmekjmUB5.webp",
    colorClass: "card--color5",
    dataCategory: "business",
  },
  {
    id: "tableau",
    title: "Tableau",
    category: "Corporate",
    description: "Display Tableau dashboards on your digital signage.",
    href: "/digital-signage-dashboard/tableau/",
    icon: "tableau.ufWBoMma2D2j.svg",
    previewImage: "tableau-preview.kHJMONx_T4Ov.jpg",
    colorClass: "card--color3",
    dataCategory: "corporate",
  },
  {
    id:"meeting-calendar",
    title: "Meetings Calendar",
    category: "Business",
    description: "Display real-time meeting room schedules, availability, and bookings on any screen with seamless Google and Outlook calendar sync.",
    href: "/digital-signage-apps/meetings-calendar",
    icon: "meeting-rrom.FPyMKWyUSkSQ.svg",
    previewImage: "meetings-calendar-preview.IOPHKQUDsNmc.webp",
    colorClass: "card--color3",
    dataCategory: "business",

  },
  {
    id: "wifi-connect",
    title: "Wi-Fi Connect",
    category: "Business",
    description: "Display Wi-Fi QR codes on digital signage screens to let customers and guests connect to your network instantly with a single scan.",
    href: "/digital-signage-apps/wifi-connect",
    icon: "wifi.f3gBI_7uCpid.svg",
    previewImage: "wifi-connect-preview.XEhw-jVEg-LA.webp",
    colorClass: "card--color4",
    dataCategory: "business",
  },
  {
    id: "building-directory",
    title: "Building Directory",
    category: "Business",
    description: "Display building directories clearly on any screen to help visitors find rooms, floors, and departments quickly.",
    href: "/digital-signage-apps/building-directory",
    icon: "building-directory.WKxpc5_i5fyM.svg",
    previewImage: "building-directory-preview.QfQ1skutzSvX.webp",
    colorClass: "card--color4",
    dataCategory: "business",
  },
  {
    id: "ms-office",
    title: "MS Office, Word, PPTX",
    category: "Business",
    description: "Showcase PowerPoint, Word, and Excel files seamlessly on your digital signage with our native app.",
    href: "/digital-signage-apps/ms-office",
    icon: "office-essentials.u4RmCVf9T2Sc.svg",
    previewImage: "office-essentials.q-ON0J306wpg.webp",
    colorClass: "card--color5",
    dataCategory: "business",
  },
  {
    id: "countdown-timer",
    title: "Countdown Timer",
    category: "Business",
    description: "Show real-time countdowns for launches, events, and limited-time offers.",
    href: "/digital-signage-apps/countdown-timer",
    icon: "countdown.S72y2ZV1CJB8.svg",
    previewImage: "countdown-preview.XISfbEZAfGeL.webp",
    colorClass: "card--color2",
    dataCategory: "business",
  },
  {
    id: "currency-exchange",
    title: "Currency Exchange Board",
    category: "Finance",
    description: "Show real-time currency rates with centralized control for instant updates.",
    href: "/digital-signage-apps/currency-exchange-board",
    icon: "currency.BklXiI0iT9s1.svg",
    previewImage: "currency-exchange-preview.zdJarmo6rx_p.webp",
    colorClass: "card--color3",
    dataCategory: "business",
  },
  {
    id: "streaming",
    title: "Stream",
    category: "Business",
    description: "Stream live video to any signage screen. Paste a standard web stream link and let viewers watch events as they happen.",
    href: "/digital-signage-apps/stream",
    icon: "icons/streaming.8Ei1psRAX2jP.svg",
    previewImage: "streaming-preview.K5YPXl2Cmt3O.jpg",
    colorClass: "card--color1",
    dataCategory: "business",
  },

];

export function AppsGrid() {
  const [filteredApps, setFilteredApps] = useState<AppCardData[]>(appsData);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeFilter, setActiveFilter] = useState("*");

  // Filter and search function
  const filterAndSearchApps = (search: string, filter: string) => {
    let filtered = appsData;

    // Apply search filter
    if (search.trim() !== "") {
      const searchLower = search.toLowerCase();
      filtered = filtered.filter(
        (app) =>
          app.title.toLowerCase().includes(searchLower) ||
          app.description.toLowerCase().includes(searchLower) ||
          app.category.toLowerCase().includes(searchLower)
      );
    }


    // Apply category filter
    if (filter !== "*") {
      const categoryClass = filter.substring(1); // Remove the dot
      filtered = filtered.filter((app) => app.dataCategory === categoryClass);
    }

    setFilteredApps(filtered);
  };

  // Handle search change
  const handleSearchChange = (search: string) => {
    setSearchTerm(search);
    filterAndSearchApps(search, activeFilter);
  };

  // Handle filter change
  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    filterAndSearchApps(searchTerm, filter);
  };

  return (
    <>
      <AppsSearchAndFilter
        onSearchChange={handleSearchChange}
        onFilterChange={handleFilterChange}
      />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
        {filteredApps.map((app, index) => (
          <AppCard key={app.id} app={app} priority={index < 4} />
        ))}
      </div>
    </>
  );
}
